import { clearToken } from '@/utils/auth';

export function doLogout() {
  clearToken();
  if (typeof navigator !== 'undefined' && /jsdom/i.test(navigator.userAgent)) {
    window.history.replaceState({}, '', '/login');
    return;
  }
  window.location.assign('/login');
}
